import { AppResponse } from "src/models/app-response";
import { Subscription, SubscriptionDetails } from "src/models/subscription";
import { SubscriptionPlan } from "src/models/subscription-plans";
import { endpoints } from "src/utils/api-endpoints";
import axios from 'src/utils/axios';

export async function subscribe(id: string ,data: Partial<SubscriptionDetails>): Promise<AppResponse<unknown>> {
  const URL = `${endpoints.subscription.subscribe(id)}`;
  try {
    const response = await axios.post(URL, data);

    return {
      success: true,
      data: response.data.data,
    };
  } catch (error) {
    return { success: false, error: error.message || 'Unknown error' };
  }
}

export async function getSubscriptionPlans(): Promise<AppResponse<SubscriptionPlan[]>> {
  const URL = `${endpoints.subscription.getSubscriptionPlans}`;
  try {
    const response = await axios.get(URL);

    return {
      success: true,
      data: response.data.plans,
    };
  } catch (error) {
    return { success: false, error: error.message || 'Unknown error' };
  }
}

export async function getSubscriptions(id: string): Promise<AppResponse<Subscription[]>> {
  const URL = `${endpoints.subscription.getSubscriptions(id)}`;
  try {
    const response = await axios.get(URL);
    return {
      success: true,
      data: response.data.data,
    };
  } catch (error) {
    return { success: false, error: error.message || 'Unknown error' };
  }
}

export async function cancelSubscription(id: string) : Promise<AppResponse<unknown>>{
  const URL = `${endpoints.subscription.cancelSubscription}`;
  try {
    const response = await axios.post(URL, {id});
    return {
      success: true,
      data: response.data
    }
  } catch (error) {
    return { success: false, error: error.message || 'Unknown error' };
  }
}
